import { useEffect, useState } from "react";
import { doc, setDoc, deleteDoc, onSnapshot } from "firebase/firestore";
import { db } from "../utils/firebase";
import { Link } from "react-router-dom";

export default function FollowersSystem({ currentUserUID, profileUserUID }) {

     const [isFollowing, setIsFollowing] = useState(false);

     // FOLLOW USER
     const handleFollow = async () => {
          if (!currentUserUID || !profileUserUID) return;

          await setDoc(doc(db, "users", profileUserUID, "followersList", currentUserUID), {
               createdAt: Date.now()
          });

          await setDoc(doc(db, "users", currentUserUID, "followingList", profileUserUID), {
               createdAt: Date.now()
          });
     };

     // UNFOLLOW USER
     const handleUnfollow = async () => {
          if (!currentUserUID || !profileUserUID) return;

          await deleteDoc(doc(db, "users", profileUserUID, "followersList", currentUserUID));
          await deleteDoc(doc(db, "users", currentUserUID, "followingList", profileUserUID));
     };



     // CHECK IF CURRENT USER FOLLOWING
     useEffect(() => {
          if (!currentUserUID || !profileUserUID) return;

          const ref = doc(db, "users", profileUserUID, "followersList", currentUserUID);
          const unsub = onSnapshot(ref, snap => setIsFollowing(snap.exists()));

          return () => unsub();
     }, [currentUserUID, profileUserUID]);

     return (
          <>
                    {currentUserUID !== profileUserUID && (
                         <button className="btn btn-follow"
                              onClick={isFollowing ? handleUnfollow : handleFollow}>
                              {isFollowing ? "Unfollow" : "Follow"}
                         </button>
                    )}
                    {currentUserUID === profileUserUID && <Link to="/profile" className="btn btn-follow">Edit Profile</Link>}
          </>
     );
}


//  // FOLLOWERS COUNT LIVE
//     useEffect(() => {
//         if (!profileUserUID) return;

//         const colRef = collection(db, "users", profileUserUID, "followersList");
//         const unsub = onSnapshot(colRef, snap => setFollowersCount(snap.size));

//         return () => unsub();
//     }, [profileUserUID]);

//     // FOLLOWING COUNT LIVE
//     useEffect(() => {
//         if (!profileUserUID) return;

//         const colRef = collection(db, "users", profileUserUID, "followingList");
//         const unsub = onSnapshot(colRef, snap => setFollowingCount(snap.size));

//         return () => unsub();
//     }, [profileUserUID]);

// <div style={{ marginBottom: 12 }}>
//                     <strong>Followers:</strong> {followersCount} <br />
//                     <strong>Following:</strong> {followingCount}
//                 </div>
